import { createContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router'

/**
 * Sair com alteração não salva pede confirmação dizendo o que se perde (docs/areas/pacientes.md,
 * "Editar dados"). A guarda cobre as saídas que a tela oferece (Voltar, Cancelar, a migalha) e o
 * fechamento da aba do navegador; quem sai sem alteração sai direto.
 */
export function useUnsavedGuard(isDirty: boolean) {
  const navigate = useNavigate()
  const [destination, setDestination] = useState<string | null>(null)

  useEffect(() => {
    if (!isDirty) return
    const warn = (event: BeforeUnloadEvent) => event.preventDefault()
    window.addEventListener('beforeunload', warn)
    return () => window.removeEventListener('beforeunload', warn)
  }, [isDirty])

  return {
    /** Sai agora se não há o que perder; senão, pergunta antes. */
    leave(to: string) {
      if (isDirty) setDestination(to)
      else navigate(to)
    },
    isAsking: destination !== null,
    stay: () => setDestination(null),
    confirm() {
      const to = destination
      setDestination(null)
      if (to) navigate(to)
    },
  }
}

/** Como a migalha do cabeçalho sai da tela: pela guarda, quando há uma em volta. */
export const LeaveContext = createContext<((to: string) => void) | null>(null)
